import React, { useState, useContext, useEffect } from 'react';
import MainNavigation from 'components/MainNavigation/MainNavigation';
import Hamburger from 'components/Hamburger/Hamburger';
import LanguageSwitcher from 'components/LanguageSwitcher/LanguageSwitcher';
import userContext from 'common/utils/userContext';
import PageLink from 'components/PageLink/PageLink';
import styles from './MobileHeader.module.scss';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames/bind';

interface Props {
  links: any[];
  appLinks: any;
  localePath: string;
  registration: {
    url: string;
    text: string;
  };
  instantPayment: {
    url: string;
    text: string;
  };
  translations: any;
  registerLoginSettings: any;
  showIncompleteDetailsAlert?: any;
  hasViewDocumentsPermission: boolean;
}

const MobileHeader = ({
  links,
  localePath,
  appLinks,
  registration,
  instantPayment,
  translations,
  registerLoginSettings,
  showIncompleteDetailsAlert,
  hasViewDocumentsPermission

}: Props) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const user = useContext(userContext);
  const SPA_PATH = 'portal';
  let myAccountLink: any;

  useEffect(() => {
    setIsOpen(false); // Hide header on location change
  }, [location]);

  {
    (links || []).map((link: any, index: number) => {
      if ((link.url || '').includes(SPA_PATH)) {
        if (link.pageTypeName == 'ArticlePage') {
          myAccountLink = link;
        }
      }
    });
  }
  return (
    <div className={styles.header}>
      <div className={styles.wrapper}>
        <Hamburger
          isActive={isOpen}
          className={styles.toggleBtn}
          onClick={() => setIsOpen(!isOpen)}
        />
        <a href={localePath}>
          <img
            src={process.env.PUBLIC_URL + '/hoist_logo_color.svg'}
            width={160}
            height={40}
            className={styles.logo}
            alt="Logo"
          />
        </a>
        {user ? (
          <a href={appLinks?.LogoutPage?.Uri} className={styles.logoutBtn}>
            {translations?.Logout}
          </a>
        ) : (
          registerLoginSettings?.loginPage && (
            <PageLink
              url={appLinks?.LoginNewPage?.Uri}
              text={translations?.Login}
              className={styles.logoutBtn}
            />
          )
        )}
      </div>
      {isOpen && (
        <div className={styles.extendedContent}>
          <div className={styles.nav_wrapper}>
            <LanguageSwitcher />
            <MainNavigation
              links={links}
              showIncompleteDetailsAlert={showIncompleteDetailsAlert}
            />
          </div>
          <div className={styles.button_wrapper}>
            {user && !hasViewDocumentsPermission && (
              
              <PageLink
                url={myAccountLink?.url}
                className={classNames(styles.button, styles.buttontransparent)}
                text={myAccountLink?.name}
              />
            )}
            {!user && registerLoginSettings?.registrationPage && (
              <PageLink
                url={registration.url}
                text={registration?.text}
                className={styles.button}
              />
            )}
            {instantPayment?.url && instantPayment?.text && (
              <PageLink
                url={instantPayment?.url}
                text={instantPayment?.text}
                className={styles.button}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileHeader;
